import type { I18nConfig } from 'fumadocs-core/i18n'

// Docs (/docs) i18n config, separate from the dashboard's own cookie-based
// i18n (lib/i18n/config.ts). The dashboard's `/en` and `/de` top-level routes
// are handled by proxy.ts and are unrelated to this — docs locales live
// entirely under `/docs` (see lib/source.ts for the URL scheme).
export const i18n: I18nConfig = {
  defaultLanguage: 'en',
  languages: ['en', 'de'],
}

export type DocsLocale = (typeof i18n.languages)[number]

export const DOCS_LOCALE_NAMES: Record<DocsLocale, string> = {
  en: 'English',
  de: 'Deutsch',
}

/** Chrome strings for docs layout (separate from dashboard i18n). */
export const DOCS_CHROME: Record<
  DocsLocale,
  {
    navTitle: string
    sectionLabel: string
    dashboard: string
    humanbyte: string
    fieldTip: string
    searchInstall: string
    searchIssues: string
    searchConfiguration: string
  }
> = {
  en: {
    navTitle: 'ByteGate / Docs',
    sectionLabel: 'Docs',
    dashboard: 'Dashboard',
    humanbyte: 'HumanByte',
    fieldTip: 'Field tip',
    searchInstall: 'Install hardware',
    searchIssues: 'Common issues',
    searchConfiguration: 'Configuration',
  },
  de: {
    navTitle: 'ByteGate / Dokumentation',
    sectionLabel: 'Doku',
    dashboard: 'Dashboard',
    humanbyte: 'HumanByte',
    fieldTip: 'Praxistipp',
    searchInstall: 'Hardware installieren',
    searchIssues: 'Häufige Probleme',
    searchConfiguration: 'Konfiguration',
  },
}
